module.exports = __webpack_public_path__ + "img/c80.e67f2b81.png";